//  Angular imports
import { Injectable, inject } from '@angular/core';
//  Third party imports
import { GenericDeserialize, Serialize } from 'cerialize';
import { RHKeyData } from 'app/records/h-key-data.record';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class HKeyManagerService {
    private cookieService = inject(CookieService);


    private key: string;

    constructor() {
        // look up h-keys from cookies
        const hKeys: Array<string> = Object.keys(this.cookieService.getAll())
            .filter(
                (key: string): boolean => key.startsWith('hKey')
            );

        // if it's unambiguous, set its key as service key
        if (hKeys.length === 1) {
            this.key = hKeys[0];
        }
    }

    public store(hKeyData: RHKeyData): void {
        this.key = `hKey-${hKeyData.accountId}`;
        const asString = JSON.stringify(Serialize(hKeyData));
        this.cookieService.set(this.key, asString as string, {
            expires: new Date(Date.now() + 60 * 60 * 1000),
            secure: true,
            sameSite: 'None'
        });
    }

    public get(): RHKeyData {
        if (!this.cookieService.check(this.key)) {
            return null;
        }

        const asObj = JSON.parse(this.cookieService.get(this.key));
        return GenericDeserialize(asObj, RHKeyData);
    }

    public delete(): void {
        this.cookieService.delete(this.key);
    }
}
